import require from '@/utils/request'
import { ReqAddObject } from '@/types/ObjectAdmin'

/**
 *
 * @param data
 * object/enableList  可用对象ID 显示分群列表tab
 */

export const AddObject = (data: ReqAddObject) => require({
  url: '/object/add',
  method: 'post',
  data
})

export const AllObjectList = () => require({
  url: '/object/list',
  method: 'get'
})

export const EnableList = () => require({
  url: 'object/enableList',
  method: 'get'
})

/**
 *
 * @param id number
 * ObjectDetail 对象详情
 */
export const ObjectDetail = (id:number) => require({
  url: '/object/detail/' + id,
  method: 'get'
})

export const ObjectUpdata = (data:ReqAddObject) => require({
  url: '/object/update',
  method: 'post',
  data
})

// 启用
export const ObjectEnble = (id:number) => require({
  url: '/object/enable/' + id,
  method: 'post'
})

// 禁用
export const ObjectDisabled = (id:number) => require({
  url: '/object/disable/' + id,
  method: 'post'
})
